import { ApprovalState } from 'models/approval';
import TaskDTO from 'models/dto/tasks/taskDTO';
import { PublicationResultStatus } from 'models/resourceLink';
import IdListDTO from './IdListDTO';
import EntityDTO from './entityDTO';
import ResourceLinkChannelDTO from './resourceLinkChannelDTO';
import { UserReadConfirmationDTO } from './userReadConfirmationDTO';

export default class ResourceLinkDTO {
  linkId: number;

  listId: number;

  ownerId?: string;

  ownerRoleId?: string;

  linkName: string;

  linkURL: string;

  linkURLFragment: string;

  publicationId?: number;

  lastPublishedVersion?: string;

  pinned: boolean;

  readRequest: boolean;

  linkTypeId?: number;

  usedCount: number;

  entity?: EntityDTO;

  listItemId?: string;

  driveItemId?: string;

  pageId?: string;

  externalId?: string;

  resourceLinkChannels?: ResourceLinkChannelDTO[];

  userReadConfirmations?: UserReadConfirmationDTO[];

  normIds?: IdListDTO;

  approvals?: TaskDTO[];

  versionInfo?: ResourceLinkVersionDTO;

  versions: ResourceLinkVersionDTO[];

  sourceDriveId?: string;

  constructor() {
    this.linkId = -1;
    this.linkName = '';
    this.linkURL = '';
    this.linkURLFragment = '';
    this.usedCount = 0;
    this.listId = 0;
    this.pinned = false;
    this.readRequest = false;
    this.versions = [];
  }
}

export class EntityLinkDTO extends EntityDTO {
  pinned: boolean;

  linkURLFragment?: string;

  constructor() {
    super();
    this.pinned = false;
  }
}

export class ResourceLinkVersionDTO {
  id: string;

  date: string | undefined;

  version: string;

  constructor() {
    this.id = '';
    this.version = '';
  }
}

export class ResourceLinkSearchDTO {
  groupId: string;

  channelId: string;

  searchText: string;

  webURLs?: string[];

  constructor() {
    this.groupId = '';
    this.channelId = '';
    this.searchText = '';
  }
}

export class ResourceLinkConversionDataDTO {
  linkId: number;

  data: string | undefined;

  constructor() {
    this.linkId = 0;
  }
}

export class PublicationResultDTO {
  publicationId: number;

  created?: string;

  createdById?: string;

  linkId: number;

  link?: ResourceLinkDTO;

  status?: PublicationResultStatus;

  result?: string;

  oldVersion?: string;

  newVersion?: string;

  lastModified?: string;

  readConfirmationsSend?: number;

  smallChange?: boolean;

  approvalCompleted?: string;

  approvalState?: ApprovalState;

  approvers?: string[];

  approvalTask?: TaskDTO;

  constructor() {
    this.publicationId = 0;
    this.linkId = 0;
  }
}
